import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

const config = {
    apiKey: process.env.REACT_APP_APIKEY,
    authDomain: "order-app-2ede0.firebaseapp.com",
    databaseURL: "https://order-app-2ede0.firebaseio.com",
    projectId: "order-app-2ede0",
    storageBucket: "order-app-2ede0.appspot.com",
    messagingSenderId: "535510383297",
    appId: "1:535510383297:web:c33967a839a28fd0"
};

firebase.initializeApp(config);
firebase.firestore();
firebase.storage();

export default firebase;
